import { makeStyles } from '@material-ui/core';
import { getThemeStyle, spacingUnits } from '../../../../../../theme/theme';

export default makeStyles(
	(theme) => ({
		root: {
			'& .MuiDialog-container': {
				backgroundColor: getThemeStyle('palettePrimary500'),
			},
			'& .MuiPaper-root': {
				backgroundColor: 'transparent',
				border: 'none',
			},
			'& .MuiLink-root': {
				fontSize: '2.4rem',
			},

			'& .MuiButton-outlinedPrimary': {
				color: getThemeStyle('paletteCommonWhite'),
				borderColor: 'rgba(255, 255, 255, 0.5)',
				'&:hover': {
					backgroundColor: 'rgba(255, 255, 255, 0.2)',
				},
			},

			'& .MuiIconButton-colorPrimary': {
				'& svg path': {
					color: getThemeStyle('paletteCommonWhite'),
					fill: getThemeStyle('paletteCommonWhite'),
				},
				'&:hover': {
					backgroundColor: 'rgba(255, 255, 255, 0.2)',
				},
			},
		},
		logo: {
			display: 'flex',
			'& > svg': {
				height: 40,
				'& path:nth-of-type(2)': {
					fill: getThemeStyle('paletteCommonWhite'),
				},
			},
		},
		logoWrapper: {
			padding: [[spacingUnits(3), spacingUnits(2.5)]],
		},
		menuItemsWrapper: {
			paddingLeft: spacingUnits(3),
			paddingRight: spacingUnits(3),
			paddingTop: spacingUnits(3),
			paddingBottom: spacingUnits(3),

			'& a': {
				color: getThemeStyle('paletteCommonWhite'),
			},

			'& a.active': {
				color: getThemeStyle('paletteSecondary100'),
			},

			'& .MuiBox-root': {
				width: '100%',
			},

			'& .MuiGrid-item': {
				textAlign: 'center',
				width: '100%',
				maxWidth: 375,
				marginLeft: 'auto',
				marginRight: 'auto',
			},

			[theme.breakpoints.up('sm')]: {
				paddingTop: spacingUnits(6),
				paddingBottom: spacingUnits(6),
			},
		},
	}),
	{ name: 'businessMobileHeader' },
);
